module.exports = __webpack_public_path__ + "static/media/cloud-sleet.06b92fee.svg";